import { Component, OnInit } from '@angular/core';
import { IAgenda, ICustomApp, INavigationLink, NavigationLinkType } from '@sv/interfaces';
import { AgendaService } from 'src/app/_services/_content/agenda.service';
import { CustomAppService } from 'src/app/_services/_content/customApp.service';
import { KeynoteService } from 'src/app/_services/_content/keynote.service';
import { NavigationService } from 'src/app/_services/_content/navigation.service';
import { NetworkingService } from 'src/app/_services/_content/networking.service';
import { ReceptionService } from 'src/app/_services/_content/reception.service';
import { WorkshopService } from 'src/app/_services/_content/workshop.service';
import { TradefairService } from 'src/app/_services/_content/_TradeFair/tradefair.service';

@Component({
  selector: 'app-agenda',
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.scss']
})
export class AgendaComponent implements OnInit {
  app: ICustomApp;
  agenda: IAgenda;
  loaded = false;

  constructor(
    private customAppService: CustomAppService,
    private receptionService: ReceptionService,
    private fairService: TradefairService,
    private keynoteService: KeynoteService,
    private networkingService: NetworkingService,
    private workshopService: WorkshopService,
    private navigationService: NavigationService,
    private agendaService: AgendaService
  ) {}

  ngOnInit(): void {
    this.customAppService.getCustomAppListener().subscribe((app) => {
      this.app = app;
      this.agendaService.getAgendaListener().subscribe((agenda) => {
        this.agenda = agenda;
        this.loaded = true;
      });
    });
  }

  async loadRoute(route: string) {
    const navigation = await this.navigationService.getCompleteNavigationById(this.app.navigation as string);
    const links = navigation.links as INavigationLink[];
    const foundLink = links.find((link) => link.route === route);
    if (foundLink !== undefined) {
      try {
        switch (foundLink.type) {
          case NavigationLinkType.Reception:
            this.receptionService.setReception(foundLink.receptionSettings);
            break;
          case NavigationLinkType.Fair:
            this.fairService.setFair(foundLink.fairSettings);
            break;
          case NavigationLinkType.Keynote:
            this.keynoteService.setKeynote(foundLink.keynoteSettings);
            break;
          case NavigationLinkType.Networking:
            this.networkingService.setNetworking(foundLink.networkingSettings);
            break;
          case NavigationLinkType.Workshop:
            this.workshopService.setWorkshop(foundLink.workshopSettings);
            break;
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
}
